import { useWindowSize } from "rooks";

const useWindowDimension = () => {
  const { innerWidth } = useWindowSize();
  const isMobile = innerWidth <= 640;
  const isTabletNotLaptop = innerWidth > 640 && innerWidth <= 1000;
  const isTablet = innerWidth > 640 && innerWidth <= 1024;
  const isDesktop = innerWidth > 1024;

  return {
    width: innerWidth,
    isMobile,
    isTablet,
    isTabletNotLaptop,
    isDesktop,
  };
};

export default useWindowDimension;
